import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#40d1e3',
    accent: '#40d1e3',
    // secondary: VuetifyThemeItem
    // info: VuetifyThemeItem
    // warning: VuetifyThemeItem
    // error: VuetifyThemeItem
    // success: VuetifyThemeItem
  },
});

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use( CKEditor );
